import { DropDownView, FileCategoriesFilter, FilterType } from '@gripp/shared-ui';
import { View } from 'react-native';

type FileCategoriesFilterMenuProps = {
  onFileCategoriesFilterOpen: () => void;
  onFileCategoriesFilterClose: () => void;
  isOpened: boolean;
  anchorRef: React.RefObject<View>;
  type: FilterType;
};

export const FileCategoriesFilterMenu = ({
  onFileCategoriesFilterClose,
  onFileCategoriesFilterOpen,
  isOpened,
  anchorRef,
  type,
}: FileCategoriesFilterMenuProps) => {
  return (
    <DropDownView
      anchorRef={anchorRef}
      isVisible={isOpened}
      onDismiss={onFileCategoriesFilterClose}
    >
      <FileCategoriesFilter goBack={onFileCategoriesFilterClose} type={type} />
    </DropDownView>
  );
};
